import { FIELD_NAMES } from '../../constants';
import { isSchedulingPreference } from '../health-care-settings/schedulingPreferencesUtils';

export const DELETE_STRATEGIES = {
  SCHEDULING_PREFERENCES: 'SCHEDULING_PREFERENCES',
  MESSAGING_SIGNATURE: 'MESSAGING_SIGNATURE',
  CREATE_TRANSACTION: 'CREATE_TRANSACTION',
};

// Removing a signature means saving an empty one rather than deleting a record.
export const EMPTY_MESSAGING_SIGNATURE = {
  signatureName: '',
  signatureTitle: '',
  includeSignature: false,
};

/**
 * Which delete call a field needs, as a description rather than a dispatch.
 * Sibling of getSubmitStrategy — same shape, same reasons.
 *
 * All three strategies close the modal afterwards, so that isn't expressed
 * here.
 */
export const getDeleteStrategy = ({
  fieldName,
  data,
  apiRoute,
  analyticsSectionName,
  convertCleanDataToPayload,
}) => {
  const payload = convertCleanDataToPayload
    ? convertCleanDataToPayload(data, fieldName)
    : data;

  if (isSchedulingPreference(fieldName)) {
    return {
      type: DELETE_STRATEGIES.SCHEDULING_PREFERENCES,
      payload,
      method: 'DELETE',
      request: {
        route: apiRoute,
        method: 'DELETE',
        fieldName,
        payload,
        analyticsSectionName,
        value: payload,
      },
    };
  }

  if (fieldName === FIELD_NAMES.MESSAGING_SIGNATURE) {
    return {
      type: DELETE_STRATEGIES.MESSAGING_SIGNATURE,
      payload: EMPTY_MESSAGING_SIGNATURE,
      method: 'POST',
    };
  }

  return {
    type: DELETE_STRATEGIES.CREATE_TRANSACTION,
    payload,
    method: 'DELETE',
  };
};
